<template>
  <tbody class="table center merchant-base-info">
    <tr>
      <th colspan="10">商户基本信息</th>
    </tr>
    <tr>
      <template v-if="details.merNo">
        <td>商户号</td>
        <td>
          <el-input :value="details.merNo" readonly />
        </td>
      </template>
      <template v-else>
        <td>档案号</td>
        <td>
          <el-input :value="details.merId" readonly />
        </td>
      </template>
      <td>执照名称</td>
      <td>
        <el-input v-model.trim="details.merPermitName" :readonly="readonly" />
      </td>
      <td>执照号码</td>
      <td>
        <el-input v-model.trim="details.merPermitNo" :readonly="readonly" />
      </td>
      <td>注册地址</td>
      <td colspan="3">
        <el-input v-model.trim="details.merPermitAddr" :readonly="readonly" />
        <span class="editWord cur-pointer" @click="showAddressDialog(0)">
          <svg-icon icon-class="map" />
        </span>
      </td>
    </tr>
    <tr>
      <td>注册时间</td>
      <td>
        <el-input v-model.trim="details.merPermitTime" :readonly="readonly" />
      </td>
      <td>执照有效期</td>
      <td>
        <el-input v-model.trim="details.merActiveTime" :readonly="readonly" />
      </td>
      <td>店铺面积</td>
      <td>
        <el-input v-model.trim="details.merAcre" :readonly="readonly" />
        <span class="editWord">㎡</span>
      </td>
      <td>实际经营地址</td>
      <td colspan="3">
        <el-input v-model.trim="details.merAddress" :readonly="readonly" />
        <span class="editWord cur-pointer" @click="showAddressDialog(1)">
          <svg-icon icon-class="map" />
        </span>
      </td>
    </tr>
    <tr>
      <td>日营业额</td>
      <td>
        <el-input v-model.trim="details.merTurnoverAvg" :readonly="readonly" />
        <span class="editWord">元</span>
      </td>
      <td>餐饮类型</td>
      <td>
        <common-select
          v-model="details.restaurantType"
          :list="restaurantType"
          :readonly="readonly"
        />
      </td>
      <td>店铺名称</td>
      <td>
        <el-input v-model.trim="details.merName" :readonly="readonly" />
      </td>
      <td>桌台数量</td>
      <td>
        <el-input v-model.trim="details.merTableNum" :readonly="readonly" />
        <span class="editWord">张</span>
      </td>
      <td>店铺客流</td>
      <td>
        <el-input v-model.trim="details.merFlow" :readonly="readonly" />
        <span class="editWord">人/日</span>
      </td>
    </tr>
    <tr>
      <td>是否连锁</td>
      <td>
        <common-select
          v-model="details.merIsChain"
          :list="merIsChain"
          :readonly="readonly"
        />
      </td>
      <td>经营年限</td>
      <td>
        <el-input v-model.trim="details.merManageTime" :readonly="readonly" />
        <span class="editWord">月</span>
      </td>
      <td>营业时间</td>
      <td>
        <el-input v-model.trim="details.merBusinesTime" :readonly="readonly" />
      </td>
      <td>人均消费</td>
      <td>
        <el-input
          v-model.trim="details.merSingleConsume"
          :readonly="readonly"
        />
        <span class="editWord">元</span>
      </td>
      <td>外卖平台</td>
      <td>
        <template v-if="readonly">
          <el-input v-model="getTakeawayType" readonly />
        </template>
        <template v-else>
          <common-select v-model="details.takeawayType" :list="takeawayType" />
        </template>
      </td>
    </tr>
    <tr>
      <td>外卖电话</td>
      <td>
        <el-input v-model.trim="details.merPhone" :readonly="readonly" />
      </td>
      <td>员工人数</td>
      <td>
        <el-input v-model.trim="details.employeeNum" :readonly="readonly" />
        <span class="editWord">人</span>
      </td>
      <td>工资支出</td>
      <td>
        <el-input v-model.trim="details.merWages" :readonly="readonly" />
        <span class="editWord">元</span>
      </td>
      <td>采购支出</td>
      <td>
        <el-input v-model.trim="details.merPurchase" :readonly="readonly" />
        <span class="editWord">元</span>
      </td>
      <td>物业支出</td>
      <td>
        <el-input v-model.trim="details.merOther" :readonly="readonly" />
        <span class="editWord">元</span>
      </td>
    </tr>
    <tr>
      <td>合同到期时间</td>
      <td>
        <el-input v-model.trim="details.contractEndDate" :readonly="readonly" />
      </td>
      <td>店铺性质</td>
      <td>
        <common-select
          v-model="details.merType"
          :list="merType"
          :readonly="readonly"
        />
      </td>
      <td>店铺租金</td>
      <td>
        <el-input v-model.trim="details.merRent" :readonly="readonly" />
        <span class="editWord">元/月</span>
      </td>
      <td>进件类型</td>
      <td colspan="3">
        <common-select
          v-model="details.source"
          :list="source"
          :readonly="readonly"
        />
        <!-- <el-input v-model.trim="details.source" :readonly="readonly" /> -->
      </td>
    </tr>
    <slot></slot>

    <!-- 地图弹窗 这里不直接使用v-model的原因是因为 在关闭的时候就直接修改父级props了
    所以采用单独传值和监听 -->
    <address-dialog
      v-if="value"
      type="merchant"
      :value="value"
      :details="details"
      @input="$emit('input', $event)"
    />
  </tbody>
</template>

<script>
import AddressDialog from '../public/CommonAddress'
export default {
  components: {
    AddressDialog
  },
  props: {
    value: Boolean,
    details: {
      type: Object,
      default() {
        return {}
      },
      comment: '商户基本信息'
    },
    readonly: {
      type: Boolean,
      default: false,
      comment: '是否不能编辑内容'
    },
    setOpertionNum: Function
  },
  data() {
    return {
      merIsChain: [
        { value: 0, label: '否' },
        { value: 1, label: '是' }
      ],
      merOwnerType: [
        { value: 0, label: '个体' },
        { value: 1, label: '商业' }
      ],
      merType: [
        { value: 0, label: '自有' },
        { value: 1, label: '租赁' }
      ],
      takeawayType: [
        { value: 0, label: '美团' },
        { value: 1, label: '饿了么' }
      ],
      restaurantType: [
        { value: 0, label: '旅游饭店' },
        { value: 1, label: '中餐厅' },
        { value: 2, label: '西餐厅' },
        { value: 3, label: '自助餐' },
        { value: 4, label: '快餐厅' },
        { value: 5, label: '大排档' },
        { value: 6, label: '茶饮店' },
        { value: 7, label: '烘焙店' }
      ],
      source: [
        { value: 1, label: '工装进件' },
        { value: 2, label: '扫拓展码 ' },
        { value: 3, label: '自行下载' }
      ]
    }
  },

  computed: {
    getTakeawayType() {
      const { details, takeawayType } = this
      const takeawayTypeArr = (details.takeawayType || '').split(',')
      let resultStr = ''

      takeawayTypeArr.forEach((el, idx) => {
        takeawayType.forEach(it => {
          if (el && ~~el == it.value) {
            resultStr += ', ' + it.label
          }
        })
      })

      return resultStr.substr(2)
    },

    // 进件类型
    filterCorpSex() {
      return function(value) {
        if (value == 1) {
          return '工装'
        } else if (value == 2) {
          return '扫码下载'
        } else if (value == 3) {
          return '自行下载'
        }
      }
    }
  },

  methods: {
    showAddressDialog(val) {
      this.$emit('setOpertionNum', val)
      this.$emit('input', true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/detailsTable.scss';
.range-input {
  max-width: 60px;
}

.editWord img {
  width: 16px;
  height: 16px;
}
</style>
